import moment from 'moment';

export default function exportarCentroCustoParaCSV(lista, empresaNome = 'empresa') {
    if (!lista || lista.length === 0) return;

    let arquivo = 'Empresa;Data Entrada;Registrado Por;Data Ocorrência;Tipo Ocorrência;Tipo Evento Ocorrêcia;Valor Total Gasto;Ocorrência\n';

    arquivo += lista.map(item => {
        const dataEntrada = moment(item.dataEntrada).format('DD/MM/YYYY');
        const dataOcorrencia = moment(item.dataOcorrencia).format('DD/MM/YYYY');
        const valor = item.valorTotalGasto ?? '';
        const ocorrencia = `"${item.ocorrencia}"`;

        return `${empresaNome};${dataEntrada};${item.registradoPor};${dataOcorrencia};${item.tipoOcorrencia};${item.tipoEventoOcorrencia};"${valor}";${ocorrencia}`;
    }).join('\n');

    const blob = new Blob(['\ufeff', arquivo], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', `CentroCusto_${empresaNome}_${moment().format('YYYYMMDD_HHmmss')}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
